import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBzZ7kc9SfpockOTFve5enVmLUJQYYw--w",
  authDomain: "a-safe-place-e0024.firebaseapp.com",
  projectId: "a-safe-place-e0024",
  storageBucket: "a-safe-place-e0024.appspot.com",
  messagingSenderId: "61209680898",
  appId: "1:61209680898:web:5138d3bb85a00d996c1b1b",
  measurementId: "G-QQ4FEMCHGY"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
